export default "__VITE_ASSET__B08LrlST__"